import {
  VendorApiMasterApi,
  AuthApi,
  Configuration,
  ContextApi,
  CustomerDataApi,
  EnvironVariablesApi,
  LivechatAgentApi,
  ExtractTextApi,
  AgentsApi,
  ChatApi,
  ChatPricingSettingsApi,
  ChatMessageApi,
  OrganizationsApi,
  PermissionsApi,
  RolesApi,
  BackupApi,
  RestoreApi
} from "../generated";
import { ConfigSettingsApi } from "../generated/api/config-settings-api";
import { DashboardApi } from "../generated/api/dashboard-api";
import { UsersApi } from "../generated/api/users-api";
import { runtimeBasePath } from "./base";

const readAccessToken = async (): Promise<string> => {
  return localStorage.getItem("token") || "";
};

export const basePath: string = runtimeBasePath;

const apiConfig: Configuration = new Configuration({
  basePath,
  accessToken: readAccessToken,
});

export const authApi: AuthApi = new AuthApi(apiConfig);
export const userApi: UsersApi = new UsersApi(apiConfig);
export const contextApi: ContextApi = new ContextApi(apiConfig);
export const agentsApi: AgentsApi = new AgentsApi(apiConfig);
export const dashboardApi: DashboardApi = new DashboardApi(apiConfig);
export const configSettingsApi: ConfigSettingsApi = new ConfigSettingsApi(
  apiConfig
);
export const customerDataApi: CustomerDataApi = new CustomerDataApi(apiConfig);
export const apiSettingsApi: VendorApiMasterApi = new VendorApiMasterApi(
  apiConfig
);
export const environVariablesApi: EnvironVariablesApi = new EnvironVariablesApi(
  apiConfig
);
export const livechatAgentApi: LivechatAgentApi = new LivechatAgentApi(
  apiConfig
);
export const extractTextApi: ExtractTextApi = new ExtractTextApi(apiConfig)

export const chatApi: ChatApi = new ChatApi(apiConfig)

export const chatPricingSettingsApi: ChatPricingSettingsApi = new ChatPricingSettingsApi(apiConfig)

export const chatMessageApi: ChatMessageApi = new ChatMessageApi(apiConfig)

export const organizationsApi: OrganizationsApi = new OrganizationsApi(apiConfig)

export const permissionsApi: PermissionsApi = new PermissionsApi(apiConfig)

export const rolesApi: RolesApi = new RolesApi(apiConfig)

export const backupApi: BackupApi = new BackupApi(apiConfig)

export const restoreApi: RestoreApi = new RestoreApi(apiConfig)

export const API_BASE = runtimeBasePath;
